import src from "IMAGE";
export default { src, width: 450, height: 450, blurWidth: 0, blurHeight: 0};
